<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Property, USP, 1x Photo:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"><i class="bi bi-trash-fill remove-block-icon"></i></a>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'PropertyUsp1xImgDesktop')"
            [blockData]="block.variables?.PropertyUsp1xImgDesktop ?? ''"
            [placeholder]="imageDesktopPlaceholder"
            variable="PropertyUsp1xImgDesktop"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>

        <div class="col-6 gx-3">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyUsp1xImageMobile')"
            [blockData]="block.variables?.PropertyUsp1xImageMobile ?? ''"
            [placeholder]="imageMobilePlaceholder"
            variable="PropertyUsp1xImageMobile"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-12 gx-3">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyUsp1xImageHref')"
            [blockData]="block.variables?.PropertyUsp1xImageHref ?? ''"
            [placeholder]="imageHrefPlaceholder"
            variable="PropertyUsp1xImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'PropertyUsp1xImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.PropertyUsp1xImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
      </div>
      <div class="row align-items-center mt-3">
        <div class="col-4 gx-3">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyUsp1xImageAlt')"
            [blockData]="block.variables?.PropertyUsp1xImageAlt ?? ''"
            [placeholder]="imageAltPlaceholder"
            variable="PropertyUsp1xImageAlt"
          ></app-block-text>
        </div>
        <div class="col-4 gx-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyUsp1xName')"
            [blockData]="block.variables?.PropertyUsp1xName ?? ''"
            [placeholder]="namePlaceholder"
            variable="PropertyUsp1xName"
          ></app-block-text>
        </div>

        <div class="col-4 gx-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'PropertyUsp1x1Usp')"
            [blockData]="block.variables?.PropertyUsp1x1Usp ?? ''"
            [placeholder]="usp1Placeholder"
            variable="PropertyUsp1x1Usp"
          ></app-block-text>
        </div>
      </div>
      <div class="row">
        <div class="col-6 gx-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'PropertyUsp1x2Usp')"
            [blockData]="block.variables?.PropertyUsp1x2Usp ?? ''"
            [placeholder]="usp2Placeholder"
            variable="PropertyUsp1x2Usp"
          ></app-block-text>
        </div>

        <div class="col-6 gx-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'PropertyUsp1x3Usp')"
            [blockData]="block.variables?.PropertyUsp1x3Usp ?? ''"
            [placeholder]="usp3Placeholder"
            variable="PropertyUsp1x3Usp"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-6" *ngIf="block.variables?.PropertyUsp1xImgDesktop">
            <a
              target="_blank"
              [href]="
                helper.getFullUrl($safeNavigationMigration(block.variables?.PropertyUsp1xImageHref))
              "
              ><img
                [src]="$safeNavigationMigration(block.variables?.PropertyUsp1xImgDesktop)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.PropertyUsp1xImageAlt)"
            /></a>
          </div>
          <div class="col-6" *ngIf="block.variables?.PropertyUsp1xImageMobile">
            <a
              target="_blank"
              [href]="
                helper.getFullUrl($safeNavigationMigration(block.variables?.PropertyUsp1xImageHref))
              "
              ><img
                [src]="$safeNavigationMigration(block.variables?.PropertyUsp1xImageMobile)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.PropertyUsp1xImageAlt)"
            /></a>
          </div>
        </div>
        <div class="row text-left">
          <p [innerHTML]="$safeNavigationMigration(block.variables?.PropertyUsp1xName)"></p>
        </div>
        <div *ngIf="block.variables?.PropertyUsp1x1Usp">
          <ul class="list-group">
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
              *ngIf="block.variables?.PropertyUsp1x1Usp"
            >
              <div class="usp-container">
                <img
                  src="https://email.valamar.com/assets/responsysimages/content/valamarri/afasfafsaf244.png"
                  height="24"
                  width="24"
                  alt=""
                />
                <p [innerHTML]="$safeNavigationMigration(block.variables?.PropertyUsp1x1Usp)"></p>
              </div>
            </li>
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
              *ngIf="block.variables?.PropertyUsp1x2Usp"
            >
              <div class="usp-container">
                <img
                  src="https://email.valamar.com/assets/responsysimages/content/valamarri/afasfafsaf244.png"
                  height="24"
                  width="24"
                  alt=""
                />
                <p [innerHTML]="$safeNavigationMigration(block.variables?.PropertyUsp1x2Usp)"></p>
              </div>
            </li>
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
              *ngIf="block.variables?.PropertyUsp1x3Usp"
            >
              <div class="usp-container">
                <img
                  src="https://email.valamar.com/assets/responsysimages/content/valamarri/afasfafsaf244.png"
                  height="24"
                  width="24"
                  alt=""
                />
                <p [innerHTML]="$safeNavigationMigration(block.variables?.PropertyUsp1x3Usp)"></p>
              </div>
            </li>
          </ul>
          <div class="col-12" *ngIf="block.variables?.PropertyUsp1xCtaLink">
            <a
              target="_blank"
              class="btn btn-primary"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.PropertyUsp1xCtaLink))"
              role="button"
              [innerHTML]="$safeNavigationMigration(block.variables?.PropertyUsp1xCtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
